/**
 * Import all universal components
 */
    import Vue from 'vue';

    Vue.component('app-icon-button', require('./AppIconButton'));
    Vue.component('app-icon', require('./AppIcon'));
    Vue.component('pane-preview-container', require('./PanePreviewContainer'));
    Vue.component('pane-header', require('./PaneHeader'));
    Vue.component('pane-content-with-sidebar', require('./PaneContentWithSidebar'));
    Vue.component('pane-header-search', require('./PaneHeaderSearch'));
    Vue.component('pane-content', require('./PaneContent'));
    Vue.component('order-details', require('./OrderDetails'));
    Vue.component('pane-section', require('./PaneSection'));
    Vue.component('inventory-block', require('./InventoryBlock'));
    Vue.component('skeleton-lines', require('./SkeletonLines'));
    Vue.component('ui-button', require('./UiButton'));
    Vue.component('ui-link', require('./UiLink'));
    Vue.component('ui-checklist', require('./UiChecklist'));
    Vue.component('ui-search-field', require('./UiSearchfield'));
    Vue.component('ui-data-list', require('./UiDataList'));
    Vue.component('ui-icon', require('./UiIcon'));
    Vue.component('ui-scrollable-container', require('./UiScrollableContainer'));
    Vue.component('ui-details', require('./UiDetails'));
    Vue.component('ui-headline', require('./UiHeadline'));
    Vue.component('ui-tab-list', require('./UiTabList'));
    Vue.component('ui-padding', require('./UiPadding'));
    Vue.component('ui-dropdown', require('./UiDropdown'));



// WEBPACK FOOTER //
// ./src/components/universal/index.js